// extracted by mini-css-extract-plugin
export default {"hero_container":"F8","hero_pic_container":"G8","hero_pic":"H8","hero_data_container":"I8","hero_data":"J8","hero_title":"K8","hero_text":"L8","hero_bottom_btn":"M8","hero_bottom_arrow":"N8"};
    if(module.hot) {
      // 1738064244223
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  